import { atom } from "recoil";

export const appSelectedCountry = atom({
    key: "appSelectedCountry",
    default: ""
});

export const appLocale = atom({
    key: "appLocale",
    default: ""
});
